<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{LabelConstant.replyTheReport}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>
</div>
<mat-dialog-content class="px-3">
    <div *ngIf="reportDetail.eventId > 0">
        <div class="report_box reject p-3 mb-3" *ngIf="reportDetail.status == reportStatus.REJECTED">
            <div class="imagebox">
                <img [src]="reportDetail.eventImages" onerror="this.src = '../../../../assets/img/about us admin.png'"
                    class="image" alt=""/>
            </div>
            <div>
                <div class="report_title WrapData">{{ reportDetail.name }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/event_calender_icon.svg" class="image" alt="" />
                        <span [innerHTML]="reportDetail.startDateTime | ordinalDate : reportDetail.endDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt="" /> {{
                        reportDetail.startDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.endDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="location"><img src="../../../../assets/icons/event_location_icon.svg" class="image" alt="" />
                        {{ reportDetail.eventAddress }}</li>
                </ul>
                <div class="amount">{{ currencySymbolConstant.euroSign }} {{ reportDetail.rate }}</div>
            </div>
            <div>
                <div class="reporter_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt="" />
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData" [title]="reportDetail.customerName">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="report_box inprocess p-3 mb-3" *ngIf="reportDetail.status == reportStatus.PENDING">
            <div class="imagebox">
                <img [src]="reportDetail.eventImages" onerror="this.src = '../../../../assets/img/about us admin.png'"
                    class="image" alt="" />
            </div>
            <div>
                <div class="report_title">{{ reportDetail.name }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/calender.svg" class="image" alt=""/>
                        <span [innerHTML]="reportDetail.startDateTime | ordinalDate : reportDetail.endDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt=""/>{{
                        reportDetail.startDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.endDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="location"><img src="../../../../assets/icons/event_location_icon.svg" class="image" alt="" />
                        {{ reportDetail.eventAddress }}</li>
                </ul>
                <div class="amount">{{ currencySymbolConstant.euroSign }} {{ reportDetail.rate }}</div>
            </div>
            <div>
                <div class="reporter_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt=""/>
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData" [title]="reportDetail.customerName">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="report_box approve p-3 mb-3"
            *ngIf="reportDetail.status == reportStatus.APPROVED || reportDetail.status == reportStatus.APPROVEDWITHREFUND">
            <div class="imagebox">
                <img [src]="reportDetail.eventImages" onerror="this.src = '../../../../assets/img/about us admin.png'"
                    class="image" alt=""/>
            </div>
            <div>
                <div class="report_title">{{ reportDetail.name }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/calender.svg" class="image" alt=""/>
                        <span [innerHTML]="reportDetail.startDateTime | ordinalDate : reportDetail.endDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt=""/>{{
                        reportDetail.startDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.endDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="location"><img src="../../../../assets/icons/event_location_icon.svg" class="image" alt="" />
                        {{ reportDetail.eventAddress }}</li>
                </ul>
                <div class="amount">{{ currencySymbolConstant.euroSign }} {{ reportDetail.rate }}</div>
            </div>
            <div>
                <div class="reporter_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt="" />
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData" [title]="reportDetail.customerName">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="reportDetail.sessionId > 0">
        <div class="report_box reject p-3 mb-3" *ngIf="reportDetail.status == reportStatus.REJECTED">
            <div>
                <div class="report_title">{{ reportDetail.className }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/calender.svg" class="image" alt="" />
                        <span
                            [innerHTML]="reportDetail.sessionStartDateTime | ordinalDate : reportDetail.sessionEndDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt="" /> {{
                        reportDetail.sessionStartDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.sessionEndDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="time"><img src="../../../../assets/icons/report_user_icon.svg" class="image" alt=""/> {{LabelConstant.hostedBy}} {{reportDetail.sessionHostedByName }}</li>
                </ul>
            </div>
            <div>
                <div class="reporter_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt="" />
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData" [title]="reportDetail.customerName">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="report_box inprocess p-3 mb-3" *ngIf="reportDetail.status == reportStatus.PENDING">
            <div>
                <div class="report_title">{{ reportDetail.className }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/calender.svg" class="image" alt="" />
                        <span
                            [innerHTML]="reportDetail.sessionStartDateTime | ordinalDate : reportDetail.sessionEndDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt=""/>{{
                        reportDetail.sessionStartDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.sessionEndDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="time"><img src="../../../../assets/icons/report_user_icon.svg" class="image" alt="" /> {{LabelConstant.hostedBy}} {{reportDetail.sessionHostedByName }}</li>
                </ul>
            </div>
            <div>
                <div class="reporter_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt=""/>
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData" [title]="reportDetail.customerName">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="report_box approve p-3 mb-3"
            *ngIf="reportDetail.status == reportStatus.APPROVED || reportDetail.status == reportStatus.APPROVEDWITHREFUND">
            <div>
                <div class="report_title">{{ reportDetail.className }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/calender.svg" class="image" alt="" />
                        <span
                            [innerHTML]="reportDetail.sessionStartDateTime | ordinalDate : reportDetail.sessionEndDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt="" />{{
                        reportDetail.sessionStartDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.sessionEndDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="time"><img src="../../../../assets/icons/report_user_icon.svg" class="image" alt="" /> {{LabelConstant.hostedBy}} {{reportDetail.sessionHostedByName }}</li>
                </ul>
                <div class="amount">{{ currencySymbolConstant.euroSign }} {{ reportDetail.amount }}</div>
            </div>
            <div>
                <div class="reporter_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt="" />
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData" [title]="reportDetail.customerName">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="report_customer_message mb-3">
        <div class="title">{{LabelConstant.customerMessage}}</div>
        <textarea class="form-control" rows="2" cols="50" disabled>{{ reportDetail.customerReason }}</textarea>
    </div>
    <div class="reply_to_reporter">
        <div class="title">{{LabelConstant.replyToReporter}}</div>
        <textarea class="form-control" rows="2" cols="50" disabled>{{ reportDetail.adminReason }}</textarea>
    </div>
</mat-dialog-content>